"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FirebaseApp {
    initializeApp(fireApp, firebaseNS) {
        this._app = fireApp;
        this.firestoreFieldValue = fireApp.firestore.FieldValue || firebaseNS.firestore.FieldValue;
        this.firestore = this._app.firestore();
        this.auth = this._app.auth();
        this.options = this._app.options;
    }
}
exports.FirebaseApp = FirebaseApp;
let _app;
if (!_app) {
    console.log('ppl-mathfluency-utils: initing...');
}
_app = _app || new FirebaseApp();
exports.app = _app;
var Types_1 = require("./identifiers/Types");
exports.Types = Types_1.Types;
//# sourceMappingURL=app.js.map